export default "__VITE_ASSET__Di3vP0g___"